import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageBanner.css';

const LanguageBanner = () => {
  const { t, i18n } = useTranslation();

  // If the language is English or the banner was dismissed, don't show it.
  if (i18n.language.startsWith('en')) {
    return null;
  }

  const handleDismiss = () => {
    i18n.changeLanguage('en');
  };

  return (
    <div className="language-banner">
      <div className="language-banner-content">
        <div className="language-banner-text">
          <p className="language-banner-primary">
            <strong>⚠️ {t('banner.warning_title', 'WARNING:')}</strong> {t('banner.warning', "We noticed you're viewing a translated version of our site. Please note that ProductionRP is strictly an English-speaking community and English is required to play.")}
          </p>
          <p className="language-banner-secondary">
            {t('banner.ai_disclaimer', "We strongly oppose the unregulated use of AI. This translated banner is our only AI element, provided purely to ensure our language requirement is clear. If you require assistance, email ")}
            <a href="mailto:contact@productionrp.org">contact@productionrp.org</a>
          </p>
        </div>
        <button onClick={handleDismiss} className="language-banner-btn">
          {t('banner.button', "I Understand")}
        </button>
      </div>
    </div>
  );
};

export default LanguageBanner;
